<section id="index-newsletter-section">
    <div class="container">
        <div class="newsletter-card">
            <div class="row align-items-center g-4">
                <div class="col-lg-6">
                    <div class="newsletter-copy">
                        <div class="newsletter-pill">
                            <span class="dot"></span>
                            <span>Join our newsletter</span>
                        </div>
                        <h2>Join our newsletter.</h2>
                        <p>We also are not fans of spam, we'll only reach out if we deem it absolutely worth your time.</p>
                        <p>Additionally, selling your personal information disgusts us, so you don't have to worry about us sharing your e-mail address either.</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <form class="newsletter-form" [formGroup]="newsletterForm" (ngSubmit)="handleNewsletterSubscriptionForm()">

                        <!-- First Name -->
                        <div class="mb-3">
                            <label for="firstName" class="form-label text-uppercase">First name</label>
                            <input 
                                id="firstName"
                                type="text" 
                                class="form-control" 
                                placeholder="John"
                                formControlName="firstName"
                                [class.is-invalid]="firstName?.invalid && (firstName?.touched || firstName?.dirty)"
                            />

                            <!-- Error Handling -->
                            @if (firstName?.errors && (firstName?.touched || firstName?.dirty)) {
                                <div class="invalid-feedback">
                                    @if (firstName?.errors?.['required']) {
                                        <span>First name is required.</span>
                                    }
                                </div>
                            }
                        </div>

                        <!-- Last Name -->
                        <div class="mb-3">
                            <label for="lastName" class="form-label text-uppercase">Last name</label>
                            <input 
                                id="lastName"
                                type="text" 
                                class="form-control" 
                                placeholder="Doe"
                                formControlName="lastName"
                                [class.is-invalid]="lastName?.invalid && (lastName?.touched || lastName?.dirty)"
                            />

                            <!-- Error Handling -->
                            @if (lastName?.errors && (lastName?.touched || lastName?.dirty)) {
                                <div class="invalid-feedback">
                                    @if (lastName?.errors?.['required']) {
                                        <span>Last name is required.</span>
                                    }
                                </div>
                            }
                        </div>

                        <!-- E-mail Address -->
                        <div class="mb-3">
                            <label for="emailAddress" class="form-label text-uppercase">E-mail Address</label>
                            <input 
                                id="emailAddress"
                                type="email" 
                                class="form-control" 
                                placeholder="john-doe@powellii.com"
                                formControlName="emailAddress"
                                [class.is-invalid]="emailAddress?.invalid && (emailAddress?.touched || emailAddress?.dirty)"
                            />

                            <!-- Error Handling -->
                            @if (emailAddress?.errors && (emailAddress?.touched || emailAddress?.dirty)) {
                                <div class="invalid-feedback">
                                    @if (emailAddress?.errors?.['required']) {
                                        <span>E-mail address is required.</span>
                                    }
                                </div>
                            }
                        </div>

                        <!-- Welcome Message -->
                        @if (subscriptionSuccess) {
                            <p class="text-success animate__animated animate__fadeInDown"><fa-icon [icon]="faCheck" class="text-success me-2"></fa-icon>Welcome aboard, {{ subscriberFirstName }}.</p>
                        } @else if (failedSubscription) {
                            <p class="text-danger">There was an error. Please try again.</p>
                        }

                        <!-- Error Message -->

                        <button type="submit" [class]="newsletterForm.get('firstName')?.value == '' || newsletterForm.get('lastName')?.value == '' || newsletterForm.get('emailAddress')?.value == '' ? 'btn btn-primary w-100 disabled' : 'btn btn-primary w-100'">
                            @if (this.isSubmitting) {
                                <div class="spinner-border text-light" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            } @else {
                                @if (newsletterForm.get('firstName')?.value == '' || newsletterForm.get('lastName')?.value == '' || newsletterForm.get('emailAddress')?.value == '') {
                                    Complete the form
                                } @else {
                                    Join the newsletter
                                }
                            }
                        </button>
                        <small class="disclaimer text-secondary">We respect your inbox. Unsubscribe anytime.</small>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
